import React, { Component } from 'react';
import { Link } from 'react-router-dom';

import Navigation from './Navigation.js';


class Home extends Component {

  constructor(props) {
    super(props);

    this.state = {
      items: []
    }
  }

  componentDidMount() {
    fetch('data.json')
      .then((response) => {
        return response.json()
      })
      .then((json) => {
        this.setState({
          items: json.exposition
        })
      });
  }
  render() {
    return (
      <div>
        <Navigation />
        <header className="header pt-9 pb-2">
          <div className="container">
            <div className="row h-100">

              <div className="col-md-6 mr-auto">
                <h3>Hélène Arfi</h3>
                <p className="text-justify">Les œuvres d’Hélène Arfi sont exposées en France et aux Etats-Unis.
                  <br />Animée depuis son plus jeune âge par la passion de la nature, elle entre à l’Ecole supérieure des arts appliqués Duperré. Elle poursuit ses études à l’Ecole des Beaux-Arts de Paris dans l’atelier de taille directe de Jean Cardot puis dans le Département de morphologie de Jean François Debord où elle étudie le corps humain en mouvement.
                  <br />Après avoir mené une carrière de styliste dans le prêt-à-porter tout en continuant la sculpture, elle décide de se consacrer à cet art à plein temps.
                  <br />Ses sujets privilégiés sont la nature, la faune sauvage et les oiseaux qu’elle observe au cours de ses nombreux voyages et dans les zoos.
                  <br />Elle travaille dans son atelier où chaque animal issu de son observation, qu’il soit peint ou sculpté, sera repensé par son imaginaire.
                </p>
                <br />
                <p className="gap-xy">
                  <a href="https://www.instagram.com/helene.arfi/" className="btn btn-label btn-warning" target="_blank">
                    <label><i className="fa fa-instagram"></i></label> Instagram
                  </a>
                </p>
                <br />
              </div>

              <div className="col-md-6">
                <Link to="/Sculpture">
                  <img className=" mt-md-7 ml-md-5 mb-2" src="assets/img/images/cigognes.jpg" alt="Cigognes - Hélène arfi" />
                </Link>
              </div>

            </div>
          </div>
        </header>

      </div>
    );
  }
}

export default Home;



// WEBPACK FOOTER //
// ./src/Home.js